import { PropsWithChildren } from 'react';

import { RibbonButtonProps } from './RibbonButton';
import { RibbonButtonOpenPanel, RibbonButtonOpenPanelProps } from './RibbonButtonOpenPanel';
import { RibbonContainer } from './RibbonContainer';
import { RibbonSeparator } from './RibbonSeparator';

// @Deprecated use RibbonPanelButton
export type OpenPanelIconProps = RibbonButtonProps;

// @Deprecated use RibbonPanelButton
export const OpenPanelIcon = ({ iconTitle, ...props }: RibbonButtonOpenPanelProps & { iconTitle?: string }) => (
  <RibbonButtonOpenPanel title={iconTitle} {...props} />
);

// @Deprecated use RibbonContainer
export const ButtonIconHorizontalGroup = (props: PropsWithChildren) => (
  <RibbonContainer orientation={'horizontal'} {...props} />
);

// @Deprecated use RibbonContainer
export const ButtonIconVerticalGroup = (props: PropsWithChildren) => (
  <RibbonContainer orientation={'vertical'} {...props} />
);

// @Deprecated use ButtonIconSeparator
export const ButtonIconSeparator = RibbonSeparator;
